import { EntityMediaType, SenderTypeEnum } from '@/types/schema';

export enum ViewMode {
  Chat = 'Chat',
  ChatHistory = 'ChatHistory',
  Notes = 'Notes',
  Content = 'Content',
}

export enum ErrorMessageTypeEnum {
  Error = 'Error',
}

export type ChatbotMessageSenderType = SenderTypeEnum | ErrorMessageTypeEnum;

export type ChatbotReferenceType = {
  id: string;
  parentId?: string;
  rootId?: string;
  name: string;
  cover: EntityMediaType | { url: string };
  type: string;
  url?: string;
  isIntegration?: boolean;
};

export type AIResponse = {
  answer: string;
  doc: string;
};

export type ChatbotMessageType = {
  id: string;
  senderType: ChatbotMessageSenderType;
  textContent: string;
  doc?: string;
  updatedAt?: Date | null;
  references?: ChatbotReferenceType[];
};

export type PinnedContentType = {
  id: string;
  type: string;
  name: string;
  parentId?: string;
  parentName?: string;
};

export enum NotesViewMode {
  Notes = 'notes',
  KnowledgeAssets = 'knowledge-assets',
}

export enum KnowledgeDocsTabs {
  MyDocs = 'my-docs',
  PendingApproval = 'pending-approval',
  Approved = 'approved',
}
